import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class InitSettingsUIAct extends SyncUIActDecorator {
    public async execute(): Promise<void> {
        // TODO dp we need it?
        this.emitter.on('General.Game.STARTED', this.onGameStarted.bind(this));
        // this.emitter.emit('UI.setStoreDefaults');
    }

    protected onGameStarted(): void {
        this.onExecuted?.();
    }

    getName(): string {
        return 'InitSettingsUIAct';
    }
}